module.exports = __webpack_public_path__ + "8980678dfc8fb5287c46651f1d9ff56a.gif";